import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import { getFederalBoundaryInfo, getStateBoundaryInfo, getLGABoundaryInfo, boundaryPopupClose } from '../../actions/mainview/mainview';

import koalaArmy from '../../static/images/koala-army.jpg';

const BoundaryPopup = () => {

  const dispatch = useDispatch(),
        appProps = useSelector(store => store.app),
        mainviewProps = useSelector(store => store.mainview),
        [federalBoundaryInfo, setFederalBoundaryInfo] = useState(null),
        [lgaBoundaryData, setLgaBoundaryData] = useState(null),
        [stateBoundaryData, setStateBoundaryData] = useState(null),
        [tabIndex, setTabIndex] = useState(0),
        [fetchCount, setFetchCount] = useState(0);
        
  useEffect(() => { // Run get data from back end only when layer selection or coords change. (i.e. user has toggled a layer or clicked a new spot)
    
    if (fetchCount > 1) return; // Only make request once

    if (mainviewProps.showFederalLayer) dispatch(getFederalBoundaryInfo(mainviewProps.boundaryCoords.lng, mainviewProps.boundaryCoords.lat));
    if (mainviewProps.showStateLayer) dispatch(getStateBoundaryInfo(mainviewProps.boundaryCoords.lng, mainviewProps.boundaryCoords.lat));
    if (mainviewProps.showLGALayer) dispatch(getLGABoundaryInfo(mainviewProps.boundaryCoords.lng, mainviewProps.boundaryCoords.lat));

    setFetchCount(fetchCount => fetchCount++);

  }, [dispatch, mainviewProps.boundaryCoords, fetchCount]);
    
  useEffect(() => { // Turn off popup if no layers left on

    if (!mainviewProps.showLGALayer && !mainviewProps.showStateLayer && !mainviewProps.showFederalLayer) dispatch(boundaryPopupClose());
    setTabIndex(0);

  }, [dispatch, mainviewProps.showLGALayer, mainviewProps.showStateLayer, mainviewProps.showFederalLayer]);

  useEffect(() => { // Run set local state after previous effect, to store data locally

    if (mainviewProps.federalBoundaryPopupData) setFederalBoundaryInfo(mainviewProps.federalBoundaryPopupData);
    if (mainviewProps.stateBoundaryPopupData) setStateBoundaryData(mainviewProps.stateBoundaryPopupData);
    if (mainviewProps.lgaBoundaryPopupData) setLgaBoundaryData(mainviewProps.lgaBoundaryPopupData);

  }, [mainviewProps.federalBoundaryPopupData, mainviewProps.stateBoundaryPopupData, mainviewProps.lgaBoundaryPopupData]);

  return (
    <div className="map__popup-content">

      <Tabs selectedIndex={ tabIndex } onSelect={ index => setTabIndex(index) }>
        <TabList>
          {
            mainviewProps.showFederalLayer &&
            federalBoundaryInfo &&
            <Tab>Federal</Tab>
          }
          {
            mainviewProps.showStateLayer &&
            stateBoundaryData &&
            <Tab>State</Tab>
          }
          {
            mainviewProps.showLGALayer &&
            lgaBoundaryData &&
            <Tab>Local Government</Tab>
          }
        </TabList>

        {
          mainviewProps.showFederalLayer &&
          federalBoundaryInfo &&
          <TabPanel>
            {
              !federalBoundaryInfo.notFoundText &&
              <>
                <p className="map__popup-text"><b>Electorate:</b> { federalBoundaryInfo.name }</p>
                <p className="map__popup-text"><b>MP name:</b> { federalBoundaryInfo.title_one && federalBoundaryInfo.title_one } { federalBoundaryInfo.title_two && federalBoundaryInfo.title_two } { federalBoundaryInfo.first_name } { federalBoundaryInfo.surname }</p>
                
                {
                  federalBoundaryInfo.email_address &&
                  <p className="map__popup-text"><b>Email address:</b> <a href={ `mailto:${ federalBoundaryInfo.email_address } ` }>{ federalBoundaryInfo.email_address }</a></p>
                }

                <p className="map__popup-text"><b>Work phone:</b> <a href={ `tel:${ federalBoundaryInfo.work_phone }` }>{ federalBoundaryInfo.work_phone }</a></p>
                <p className="map__popup-text"><b>Party:</b> { federalBoundaryInfo.party }</p>
                <p className="map__popup-text"><b>Postal address:</b> { federalBoundaryInfo.postal_address }, { federalBoundaryInfo.postal_suburb }, { federalBoundaryInfo.state }, { federalBoundaryInfo.postal_code }</p>

                <p className="map__popup-text"><b>Koala popuplation estimate:</b> { federalBoundaryInfo.population_estimate }</p>
                <p className="map__popup-text"><b>Remaining Habitat 2019:</b> { federalBoundaryInfo.habitat_remaining_2019 }%</p>
                <p className="map__popup-text"><b>Act or Axe rating:</b> { federalBoundaryInfo.act_or_axe_rating } <img src={ +federalBoundaryInfo.act_or_axe_rating < 3 ? appProps.applicationLinks?.images?.axe : appProps.applicationLinks?.images?.act } alt="Act or Axe logo" style={{ width: 35, height: 'auto', display: 'inline-block', verticalAlign: 'middle', marginLeft: 10 }} /></p>
                <p className="map__popup-text"><b>Koala sightings in area:</b> { federalBoundaryInfo.sightings_count }</p>

                {
                  federalBoundaryInfo.act_or_axe_link !== '#REF!' &&
                  <p className="map__popup-text"><b>Act or Axe link:</b> <a href={ federalBoundaryInfo.act_or_axe_link } target="_blank" rel="noopener noreferrer">{ federalBoundaryInfo.act_or_axe_link }</a></p>
                }

                {
                  appProps.applicationLinks?.links.act_or_axe_assesment &&
                  <p className="map__popup-text"><a href={ appProps.applicationLinks?.links.act_or_axe_assesment } target="_blank" rel="noopener noreferrer">See how we asses our politicians</a></p>
                }

                <a href="https://www.savethekoala.com/koala-army" target="_blank" rel="noopener noreferrer" style={{ marginTop: 15, display: 'block' }}>
                  <img src={ koalaArmy } alt="Koala army - We need you!" style={{ maxWidth: '100%' }} />
                </a>
              </>
            }

            {
              federalBoundaryInfo.notFoundText &&
              <p className="map__popup-text">{ federalBoundaryInfo.notFoundText }</p>
            }
          </TabPanel>
        }
        
        {
          mainviewProps.showStateLayer &&
          stateBoundaryData &&
          <TabPanel>
            <p className="map__popup-text map__popup-text--capitalize"><b>Electorate Name:</b> { stateBoundaryData.name.toLowerCase() }</p>
            <p className="map__popup-text"><b>State:</b> { stateBoundaryData.abb_name }</p>
            <p className="map__popup-text"><b>Koala sightings in area:</b> { stateBoundaryData.sightings_count }</p>
          </TabPanel>
        }

        {
          mainviewProps.showLGALayer &&
          lgaBoundaryData &&
          <TabPanel>
            <p className="map__popup-text map__popup-text--capitalize"><b>Local Government:</b> { lgaBoundaryData.name.toLowerCase() }</p>
            <p className="map__popup-text"><b>State:</b> { lgaBoundaryData.state }</p>
            <p className="map__popup-text"><b>Koala sightings in area:</b> { lgaBoundaryData.sightings_count }</p>

            {
              appProps.applicationLinks?.links.trees &&
              <p className="map__popup-text"><b>Preferred Tree Species:</b> <a rel="noopener noreferrer" href={ appProps.applicationLinks?.links.trees } target="_blank">See more information on trees for Koalas</a></p>
            }
          </TabPanel>
        }
      </Tabs>
      
    </div>
  );

}

export default BoundaryPopup;